// extracted by mini-css-extract-plugin
export default {"pt5":"CustomList_pt5__X0RzC","cardHeader":"CustomList_cardHeader__QCX3v"};